import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '@env/environment';

export type IdentityProviderCode = 'OLIMPIA' | 'BECOME';

@Injectable({
  providedIn: 'root'
})
export class IdentityValidationProviderService {
  constructor(private httpClient: HttpClient) {}

  /** Proveedor configurado para el asesor de la sesión; ante cualquier error se usa Olimpia. */
  resolveForOnboarding(): Observable<IdentityProviderCode> {
    return this.httpClient
      .get<any>(`${environment.serverUrl}/app/identityValidationProvider/resolve`, {
        params: { process: 'ONBOARDING' }
      })
      .pipe(
        map((response) => (response?.provider?.code === 'BECOME' ? 'BECOME' : 'OLIMPIA') as IdentityProviderCode),
        catchError((error) => {
          console.error('Error resolving identity provider', error);
          return of<IdentityProviderCode>('OLIMPIA');
        })
      );
  }
}
